import { IconShare, Tooltip } from '@issuu/silkscreen';
import React, { useState } from 'react';

import { ActionButton, ActionIcon } from './ActionButton';
import { ShareBox } from './ShareBox';

const Share: React.FC = () => {
    const [isShareBoxShowing, setIsShareBoxShowing] = useState<boolean>(false);
    return (
        <>
            <Tooltip id="share_tooltip" size="medium" text="Share the publication">
                <ActionButton
                    aria-describedby="share_tooltip"
                    onClick={() => setIsShareBoxShowing(true)}
                >
                    <ActionIcon>
                        <IconShare />
                    </ActionIcon>
                    Share
                </ActionButton>
            </Tooltip>
            {isShareBoxShowing ? (
                <ShareBox closeHandler={() => setIsShareBoxShowing(false)} />
            ) : null}
        </>
    );
};

export default Share;
